
const $ = require('jquery');

const postscribeScript = require('postscribe-script');


$(() => {
	$('[data-apply="postscribe-script"]').each(function () {
		const $this = $(this);

		const src = $this.attr('data-postscribe-script-src');

		postscribeScript($this, src)
			.catch(e => {
				console.warn(e);
			});
	});
});
